/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChatLlmCallDto } from '../../models/chat-llm-call-dto';

export interface LlmControllerChatLlmStreaming$Params {
  ilsId: string;
      body: ChatLlmCallDto
}

export function llmControllerChatLlmStreaming(http: HttpClient, rootUrl: string, params: LlmControllerChatLlmStreaming$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, llmControllerChatLlmStreaming.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

llmControllerChatLlmStreaming.PATH = '/llm/{ilsId}/stream';
